import { useEffect, useMemo } from "react";
import { Error404 } from "@ugg/shared/components/common/Error404";
import { useParams } from "react-router";
import { getRiotAssetsContext, type ItemMap } from "@outplayed/riot-assets";
import { getItemDescription } from "./ItemsPage/getItem";
import { ItemPage } from "./ItemsPage/ItemPage";

export function ItemPageContainer() {
  const { useNewRiotItems, getItemIdFromName, useItemsWiki } = getRiotAssetsContext();
  const { itemName } = useParams<{ itemName: string }>();
  const itemsList = useItemsWiki({ ssr: true });

  const data = itemsList && itemsList.data;

  const { data: items, loading: fetchingItems, error: errorItems } = useNewRiotItems({ ssr: true });
  const itemId = getItemIdFromName(itemName, { optionalData: items });

  const cloneItems = useMemo(() => cleanItemData(items || {}), [items]);
  const itemData = cloneItems && itemId !== null ? cloneItems[itemId] : null;
  const itemDescription = itemId ? getItemDescription(itemId, itemData, data, { render: true }) : "";

  // Scroll to top
  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, [itemId]);

  if (fetchingItems) {
    return (
      <div className="w-full">
        <div className="spinthatshit-loader" style={{ height: "85vh" }}>
          <div className="spinner" />
        </div>
      </div>
    );
  }

  if (!itemData || itemId === null) {
    return <Error404 className="w-full" />;
  }

  return <ItemPage itemId={itemId} itemDescription={itemDescription} itemData={itemData} items={items} />;
}

function cleanItemData(data: ItemMap) {
  const removedItems = {
    Emberknife: 1035,
    Hailblade: 1039,
    "Obsidian Edge": 1040,
    "Penetrating Bullets": 1500,
    Fortification: 1501,
    "Reinforced Armor": 1502,
    Vanguard: 1504,
    "Lightning Rod": 1505,
    Overcharged: 1507,
    "Anti-tower Socks": 1508,
    Gusto: 1509,
    "Phreakish Gusto": 1510,
    "Super Mech Armor": 1511,
    "Super Mech Power Field": 1512,
    "Turret Plating": 1515,
    "Structure Bounty": 1516,
    OverchargedHA: 1520,
    "Tower Power-up": 1522,
    "Warden's Eye": 1503,
    OvererchargedHA: 1520,
    "Tower Power-Up": 1522,
    "Scarecrow Effigy": 3330,
    "The Golden Spatula": 4403,
    "Stirring Wardstone": 4641,
    Bloodward: 7008,
    "Sandshrike's Claw": 7000,
    "Wyrmfallen Sacrifice": 7007,
    "Seat of Command": 7022,
  };
  const removedItemsIds = Object.values(removedItems);

  const cloneData: ItemMap = JSON.parse(JSON.stringify(data));

  //Remove "into" array if item it goes "into" doesn't exist anymore
  for (var key in cloneData) {
    const into = cloneData[key]["into"];
    if (into && removedItemsIds.includes(parseInt(into?.[0]))) {
      cloneData[key]["into"] = [];
    }
  }

  //Manually adding description for Imperial Mandate
  if (cloneData?.hasOwnProperty(4005)) {
    cloneData[4005]["into"] = [];
    cloneData[4005]["description"] =
      "<mainText><stats><attention>40</attention> Ability Power<br><attention>200</attention> Health<br><attention>20</attention> Ability Haste<br><attention>100%</attention> Base Mana Regen</stats><br><li><passive>Coordinated Fire:</passive> Abilities that <status>Slow</status> or <status>Immobilize</status> a champion deal bonus damage and mark them. Ally champion damage detonates the mark, dealing additional damage and granting you both Move Speed. </mainText><br>";
  }

  return cloneData;
}
